<template>
    <div class="category-page">
        <!-- 顶部搜索框（不悬浮） -->
        <header class="header">
            <div class="search-box" @click="toSearch">
                <div class="search-box-inner">
                    <span class="search-icon">🔍</span>
                    <input type="text" placeholder="不打糖的耙耙柑" v-model="searchValue" @click.stop />
                </div>
            </div>
            <!-- 横向分类：只显示前4个，右侧展开按钮 -->
            <div class="horizontal-categories">
                <div class="scroll-wrapper">
                    <div class="cat-scroll">
                        <div v-for="cat in displayedCategories" :key="cat.name" class="h-cat-item"
                            @click="selectCategory(cat.name)">
                            <img :src="'/static/home/' + cat.url" class="h-cat-icon" alt="" />
                            <div class="h-cat-name" :class="{ active: currentCategory === cat.name }">{{ cat.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="expand-btn" @click="showDropdown = true">
                    <span>展开</span>
                </div>
            </div>
        </header>

        <!-- 左右主体结构 -->
        <div class="main-layout">
            <!-- 左侧分类：只有文字，滚动 -->
            <div class="left-categories">
                <div v-for="cat in categoryList" :key="cat.name" class="cat-text"
                    :class="{ active: currentCategory === cat.name }" @click="selectCategory(cat.name)">
                    <div class="cat-text-inner">
                        {{ cat.name }}
                    </div>
                </div>
            </div>

            <!-- 右侧商品列表（一行一个，左右结构） -->
            <div class="right-products">
                <div class="products-list">
                    <img src="/static/cate/shop.png" alt="" style="width: 100%;height: 80px;margin-bottom: 3px;">
                    <div v-for="(item, idx) in currentGoodsList" :key="idx" class="product-card"
                        @click="viewGoods(item)">
                        <img src="/static/home/Rectangle 1384.png" class="product-img" alt="" />
                        <div class="product-info">
                            <div class="product-title">{{ item.title }}</div>
                            <div class="product-desc">{{ item.desc }}</div>
                            <div class="tags">
                                <span class="price-tag">新人首单价</span>
                                <span class="price-tag">近30天最低价</span>
                            </div>
                            <div class="price-info">
                                <span class="current-price"><span style="font-size: 10px;">¥</span>{{ item.price
                                    }}</span>
                            </div>
                            <div class="price-row">
                                <div class="price-info">
                                    <span style="font-size: 12px;color: #bbb;">秒杀价</span>
                                    <span class="old-price">¥{{ item.oldPrice }}</span>
                                </div>
                                <div class="add-btn">+</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="currentGoodsList.length === 0" class="empty-tip">暂无商品</div>
            </div>
        </div>

        <!-- 顶部下拉框（全部分类） -->
        <div v-if="showDropdown" class="dropdown-overlay" @click.self="closeDropdown">
            <div class="dropdown-container">
                <div class="dropdown-header">
                    <span class="dropdown-title">全部分类</span>
                </div>
                <div class="dropdown-categories">
                    <div v-for="cat in categoryList" :key="cat.name" class="dropdown-cat-item"
                        @click="selectCategoryFromDropdown(cat.name)">
                        <img :src="'/static/home/' + cat.url" class="dropdown-icon" alt="" />
                        <span>{{ cat.name }}</span>
                    </div>
                </div>
                <!-- 底部收起按钮 -->
                <div class="dropdown-footer" @click="closeDropdown">
                    收起
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CategoryPage",
    data() {
        return {
            searchValue: "",
            // 分类列表（与设计图一致，含图片）
            categoryList: [
                { name: "超值抢购", url: "Frame 286.png" },
                { name: "甄选精品", url: "Frame 290.png" },
                { name: "家居用品", url: "Frame 291.png" },
                { name: "生活日化", url: "Frame 292.png" },
                { name: "数码电器", url: "Frame 293.png" },
                { name: "个人养护", url: "Frame 294.png" },
                { name: "健康养生", url: "Frame 295.png" },
                { name: "酒水饮料", url: "Frame 296.png" },
                { name: "粮油食品", url: "Rectangle 1363.png" },
                { name: "成人用品", url: "Frame 297.png" },
            ],
            // 当前选中的分类
            currentCategory: "超值抢购",
            // 控制下拉框显示
            showDropdown: false,
            // 商品数据（按分类名映射）
            goodsMap: {
                超值抢购: [
                    { id: 1, title: "荣事达电饭煲", desc: "蒸煮煎炒焖炖涮 智能菜单", price: "15.09", oldPrice: "29.90" },
                    { id: 2, title: "脆甜爆浆小番茄", desc: "新鲜直送 皮薄多汁", price: "0.01", oldPrice: "15.09" },
                    { id: 3, title: "春和景明野餐垫", desc: "赴一场与自然的约会", price: "29.90", oldPrice: "59.90" },
                    { id: 4, title: "便携榨汁杯", desc: "无线充电 随行鲜榨", price: "59.00", oldPrice: "99.00" },
                ],
                甄选精品: [
                    { id: 11, title: "精品牛肉礼盒", desc: "澳洲进口 原切牛排", price: "118.00", oldPrice: "198.00" },
                    { id: 12, title: "山茶花洗护套装", desc: "滋养修护 爆款返场", price: "69.00", oldPrice: "129.00" },
                    { id: 13, title: "有机五常大米", desc: "10斤装 稻香浓郁", price: "55.90", oldPrice: "89.90" },
                    { id: 14, title: "智能空气炸锅", desc: "无油烹饪 健康生活", price: "189.00", oldPrice: "299.00" },
                ],
                家居用品: [
                    { id: 21, title: "荣事达电饭煲", desc: "蒸煮煎炒焖炖涮 多功能", price: "149.00", oldPrice: "299.00" },
                    { id: 22, title: "记忆绵枕头", desc: "护颈助眠 舒适透气", price: "79.00", oldPrice: "159.00" },
                    { id: 23, title: "免打孔置物架", desc: "厨房浴室收纳神器", price: "25.90", oldPrice: "49.90" },
                    { id: 24, title: "静音落地扇", desc: "节能大风量", price: "199.00", oldPrice: "399.00" },
                ],
                生活日化: [
                    { id: 31, title: "洗衣凝珠", desc: "除菌留香 一颗洗净", price: "39.90", oldPrice: "79.90" },
                    { id: 32, title: "厨房油污净", desc: "强力去油 清新柠檬", price: "19.90", oldPrice: "39.90" },
                    { id: 33, title: "柔顺剂", desc: "持久留香 护衣防静电", price: "29.90", oldPrice: "59.90" },
                ],
                数码电器: [
                    { id: 41, title: "无线蓝牙耳机", desc: "降噪长续航", price: "99.00", oldPrice: "199.00" },
                    { id: 42, title: "快充充电宝", desc: "20000mAh 大容量", price: "89.00", oldPrice: "149.00" },
                    { id: 43, title: "智能手环", desc: "心率监测 运动模式", price: "129.00", oldPrice: "229.00" },
                    { id: 44, title: "便携投影仪", desc: "家庭影院 高清画质", price: "499.00", oldPrice: "899.00" },
                ],
                个人养护: [
                    { id: 51, title: "电动牙刷", desc: "声波震动 清洁亮白", price: "79.00", oldPrice: "159.00" },
                    { id: 52, title: "补水喷雾仪", desc: "纳米细雾 深层补水", price: "49.00", oldPrice: "99.00" },
                    { id: 53, title: "按摩筋膜枪", desc: "放松肌肉 缓解疲劳", price: "199.00", oldPrice: "399.00" },
                ],
                健康养生: [
                    { id: 61, title: "红枣枸杞茶", desc: "滋补养生 独立包装", price: "29.90", oldPrice: "59.90" },
                    { id: 62, title: "智能体脂秤", desc: "精准测量 多项数据", price: "59.00", oldPrice: "119.00" },
                    { id: 63, title: "艾草贴", desc: "温经通络 缓解酸痛", price: "19.90", oldPrice: "39.90" },
                ],
                酒水饮料: [
                    { id: 71, title: "精酿原浆啤酒", desc: "醇厚麦香 泡沫细腻", price: "69.00", oldPrice: "129.00" },
                    { id: 72, title: "NFC橙汁", desc: "鲜榨非浓缩", price: "15.90", oldPrice: "29.90" },
                    { id: 73, title: "气泡水组合", desc: "0糖0脂 清爽口感", price: "39.90", oldPrice: "79.90" },
                ],
                粮油食品: [
                    { id: 81, title: "五常大米", desc: "当季新米 软糯香甜", price: "49.90", oldPrice: "89.90" },
                    { id: 82, title: "压榨花生油", desc: "5L 物理压榨", price: "89.00", oldPrice: "159.00" },
                    { id: 83, title: "有机小米", desc: "杂粮礼盒 营养早餐", price: "35.90", oldPrice: "69.90" },
                ],
                成人用品: [
                    { id: 91, title: "安全套超薄装", desc: "舒适贴合 保密发货", price: "29.90", oldPrice: "59.90" },
                    { id: 92, title: "情趣礼盒", desc: "浪漫惊喜", price: "99.00", oldPrice: "199.00" },
                    { id: 93, title: "润滑液", desc: "水溶配方 温和不刺激", price: "19.90", oldPrice: "39.90" },
                ],
            },
        };
    },
    mounted() {
        // 页面加载时检查URL参数
        this.initFromQuery();
    },
    computed: {
        // 横向只显示前4个分类
        displayedCategories() {
            return this.categoryList.slice(0, 4);
        },
        currentGoodsList() {
            return this.goodsMap[this.currentCategory] || [];
        },
    },
    watch: {
        '$route.query.category'(newCategory) {
            if (newCategory) {
                const categoryExists = this.categoryList.some(cat => cat.name === newCategory);
                if (categoryExists) {
                    this.currentCategory = newCategory;
                }
            }
        }
    },
    methods: {
        // 新增：从URL参数初始化分类
        initFromQuery() {
            const categoryFromQuery = this.$route.query.category;
            if (categoryFromQuery) {
                const categoryExists = this.categoryList.some(cat => cat.name === categoryFromQuery);
                if (categoryExists) {
                    this.currentCategory = categoryFromQuery;
                }
            }
        },

        selectCategory(catName) {
            this.currentCategory = catName;
            this.updateUrlParam(catName);
        },
        selectCategoryFromDropdown(catName) {
            this.currentCategory = catName;
            this.updateUrlParam(catName);
            this.closeDropdown();
        },

        updateUrlParam(category) {
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    category: category
                }
            });
        },
        closeDropdown() {
            this.showDropdown = false;
        },
        toSearch() {
            if (this.searchValue.trim()) {
                console.log("搜索:", this.searchValue);
                alert(`搜索功能：${this.searchValue}`);
            } else {
                alert("请输入搜索内容");
            }
        },
        viewGoods(item) {
            console.log("查看商品:", item);
            alert(`查看商品：${item.title}`);
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.category-page {
    max-width: 450px;
    margin: 0 auto;
    background-color: #f8f8f8;
    min-height: 100vh;
    padding-bottom: 20px;
}

/* 头部搜索框（无悬浮） */
.header {
    background: #FFFFFF;
    padding: 12px 0 0 16px;
}

.search-box {
    width: 244px;
    height: 34px;
    background: #EFEFEF;
    border-radius: 36px;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.search-box-inner {
    display: flex;
    align-items: center;
    flex: 1;
}

.search-icon {
    font-size: 16px;
    color: #666;
    margin-right: 4px;
}

.division {
    width: 0;
    height: 20px;
    border-left: 1px solid #8b8b8b;
    margin: 0 8px;
}

.search-box-inner input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 14px;
    background: transparent;
}

.search-btn {
    width: 46px;
    height: 28px;
    background: #06cf33;
    border-radius: 14px;
    font-size: 12px;
    color: #fff;
    line-height: 28px;
    text-align: center;
    margin-left: 8px;
}

/* 横向分类 - 只显示前4个，无滚动条 */
.horizontal-categories {
    display: flex;
    align-items: center;
    background-color: #fff;
    margin: 8px 0;
    border-radius: 12px;
    padding: 8px 0 0;
    position: relative;
}

.scroll-wrapper {
    flex: 1;
    overflow-x: visible;
    /* 禁止横向滚动 */
}

.cat-scroll {
    display: flex;
    white-space: nowrap;
    justify-content: space-between;
}

.h-cat-item {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
}

.h-cat-name {
    font-size: 12px;
    color: #000000;
    width: 60px;
    height: 20px;
    text-align: center;
    line-height: 20px;
}

.h-cat-name.active {
    width: 60px;
    height: 20px;
    color: #FFFFFF;
    background: #06CF33;
    border-radius: 10px;
}

.h-cat-icon {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.expand-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
    font-size: 14px;
    color: #FFFFFF;
    background: #06CF33;
    margin-left: 8px;
    white-space: nowrap;
    height: 88px;
    writing-mode: vertical-lr;
}

.expand-btn:active {
    opacity: 0.8;
}

/* 左右主体布局 */
.main-layout {
    display: flex;
    gap: 12px;
    padding: 0 16px 0 0;
    margin-top: 8px;
    height: calc(100vh - 180px);
    overflow: hidden;
}

.left-categories {
    width: 90px;
    flex-shrink: 0;
    border-radius: 12px;
    overflow-y: auto;
    padding: 12px 0;
}

.cat-text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 77px;
    height: 50px;
    font-size: 12px;
    color: #333;
    position: relative;
    padding: 10px 0;
}

.cat-text.active {
    width: 77px;
    height: 50px;
    background: #FEFFFF;
    color: #06cf33;
    font-weight: 500;
    padding: 10px 0;
    text-align: center;
}

.cat-text.active .cat-text-inner {
    width: 100%;
    border-left: 6px solid #06CF33;
}

.right-products {
    flex: 1;
    overflow-y: auto;
    border-radius: 12px;
    padding: 12px;
}

.products-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.product-card {
    display: flex;
    gap: 6px;
    background: #fff;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: transform 0.1s;
    align-items: center;
}

.product-card:active {
    transform: scale(0.98);
}

.product-img {
    width: 108px;
    height: 108px;
    border-radius: 8px;
    object-fit: cover;
    background-color: #f0f0f0;
    flex-shrink: 0;
}

.product-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 8px 6px;
}

.product-title {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 1.4;
    text-align: left;
}

.product-desc {
    margin: 6px 0;
    font-weight: 300;
    font-size: 10px;
    color: #666;
    text-align: left;
}

.tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.price-tag {
    height: 10px;
    border-radius: 2px;
    border: 1px solid #FF0000;
    text-align: center;
    color: #FF0000;
    font-size: 5px;
    margin-right: 6px;
    padding: 0 3px;
    line-height: 10px;
}

.price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4px;
}

.price-info {
    display: flex;
    align-items: baseline;
    gap: 8px;
}

.current-price {
    font-size: 18px;
    font-weight: 800;
    color: #ff3b2f;
}

.old-price {
    font-size: 12px;
    color: #bbb;
    text-decoration: line-through;
}

.add-btn {
    width: 17px;
    height: 17px;
    background: #06cf33;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
}

.add-btn:active {
    transform: scale(0.95);
}

.empty-tip {
    text-align: center;
    padding: 40px 0;
    color: #999;
    font-size: 14px;
}

/* 下拉框样式 */
.dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    display: flex;
    justify-content: center;
}

.dropdown-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    max-height: 80vh;
    overflow-y: auto;
    animation: slideDown 0.25s ease;
}

@keyframes slideDown {
    from {
        transform: translateY(-100%);
    }

    to {
        transform: translateY(0);
    }
}

.dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;
}

.dropdown-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

/* 底部收起按钮样式 */
.dropdown-footer {
    padding: 14px 20px;
    text-align: center;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    background-color: #fff;
    border-top: 1px solid #eee;
    cursor: pointer;
    transition: background-color 0.2s;
}

.dropdown-footer:active {
    background-color: #f5f5f5;
}

.dropdown-categories {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    padding: 20px 16px;
}

.dropdown-cat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-size: 12px;
    color: #333;
    transition: 0.1s;
}

.dropdown-cat-item:active {
    opacity: 0.6;
}

.dropdown-icon {
    width: 50px;
    height: 50px;
    object-fit: contain;
    background-color: #f5f5f5;
    border-radius: 50%;
    padding: 8px;
}
</style>


// WEBPACK FOOTER //
// src/views/Categories.vue